module.exports = __webpack_public_path__ + "static/media/inspecting-bill-finance-document.71afbbdf.png";